import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const TestStatus = styled.div<{ $hasError?: boolean; theme: { token: GlobalToken } }>`
  width: 100%;
  background: ${({ theme: { token } }) => token.colorBgContainer};
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: ${({ $hasError, theme: { token } }) =>
    $hasError ? `1px solid ${token.colorError}` : `1px solid transparent`};

  .card-header {
    align-self: stretch;
    min-height: 3.625rem;
    border-bottom: 0.0625rem solid ${({ theme: { token } }) => token.colorBorder};
    display: flex;
    width: 100%;
  }

  .card-header-content {
    flex: 1 1 0%;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;
    border-top-left-radius: ${({ theme: { token } }) => token.borderRadius}px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.625rem;
    overflow: hidden;
    max-width: calc(100% - 3.5rem);
  }

  .card-header-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    overflow: hidden;
  }

  .card-title-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 0;
    overflow: hidden;
  }

  .card-title {
    width: 100%;
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeXS}px; // Default small size for mobile
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: 1.25rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;

    @media (min-width: ${({ theme: { token } }) => token.screenSM}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px; // Larger size for bigger screens
      line-height: 1.375rem;
    }
  }

  .card-sub-title {
    width: 100%;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeXS}px;
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    line-height: 1.25rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-header-actions {
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    border-top-right-radius: ${({ theme: { token } }) => token.borderRadius}px;
    border-left: 0.0625rem solid ${({ theme: { token } }) => token.colorBorder};
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card-action-icon-wrapper {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    & svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;

export const Content = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .card-content-body {
    align-self: stretch;
    height: 96px;
    padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingSM}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .card-menu-item {
    align-self: stretch;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card-menu-item-content {
    flex: 1 1 0;
    height: 27px;
    padding: 17px 0;
    border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
  }

  .card-icon-wrapper {
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pass-fail-width {
    width: 90%;
  }

  .hidden-visibility {
    visibility: hidden;
  }
  .test-result-common-wrapper {
    margin-left: 30px;
  }

  .testing-wrapper {
    color: ${({ theme: { token } }) => token.colorPrimary};
    background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
    display: flex;
    align-items: flex-start;
    padding: 3px;
  }

  .not-tested-wrapper {
    color: ${({ theme: { token } }) => token.colorText};
    background-color: ${({ theme: { token } }) => token.colorFillAlter};
    display: flex;
    padding: 1px;
    align-items: center;
    border: ${({ theme: { token } }) => token.lineWidth}px solid ${({ theme: { token } }) => token.colorBorder};
    border-radius: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  .failed-test-wrapper {
    color: ${({ theme: { token } }) => token.colorError};
    background-color: ${({ theme: { token } }) => token.colorErrorBg};
    display: flex;
    padding: 1px;
    border: 1px solid ${({ theme: { token } }) => token.colorErrorBorder};
    align-items: center;
    border-radius: ${({ theme: { token } }) => token.paddingXXS}px;
    font-size: 11px;
  }

  .pass-test-wrapper {
    color: ${({ theme: { token } }) => token.colorSuccess};
    background-color: ${({ theme: { token } }) => token.colorSuccessBg};
    display: flex;
    padding: 1px;
    border: 1px solid ${({ theme: { token } }) => token.colorSuccessBorder};
    align-items: center;
    border-radius: ${({ theme: { token } }) => token.paddingXXS}px;
    font-size: 11px;
  }

  .test-content-wrapper {
    margin-left: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  .status-content-common {
    margin-top: 2.5px;
  }

  .testing-color {
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .card-text-container {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .card-menu-text {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-style: normal;
    font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    line-height: ${({ theme: { token } }) => token.lineHeight}px;
    word-wrap: break-word;
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  .test-data-wrapper {
    display: flex;
    width: fit-content;
    padding: 5px;
  }

  .margin-result-second-wrapper {
    display: flex;
    margin-left: 43px;
  }
`;

export const CardWrapper = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  height: 14.125rem;
  display: flex;

  @media (min-width: ${({ theme: { token } }) => token.screenSM}px) {
    width: 17.625rem;
  }
`;

export const Footer = styled.div<{ theme: { token: GlobalToken } }>`
  margin-top: 10px;
  align-self: stretch;
  height: 2rem;
  padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px
    ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXXS}px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .card-comment-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
    height: 1.5rem;
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
    cursor: pointer;
    margin-right: auto;

    &:hover {
      background: ${({ theme: { token } }) => token.colorFillSecondary};
    }
  }

  .card-comment-icon-wrapper {
    width: 0.875rem;
    height: 0.875rem;
    position: relative;
    overflow: hidden;
  }

  .card-comment-button-text {
    color: ${({ theme: { token } }) => token.colorText};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    line-height: 1.25rem;
  }

  .card-no-power-icon-wrapper {
    width: ${({ theme: { token } }) => token.paddingLG}px;
    height: ${({ theme: { token } }) => token.paddingLG}px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
